import React from 'react';
import classNameBind from 'classnames/bind';
import ActionList from '../../../ActionList';
import { TextField } from '../../../TextField';

import styles from './CustomDimensionsList.module.css';

const bindClasses = classNameBind.bind(styles);

const CustomDimensionsList = ({
  dimensions,
  search,
  onItemSelected,
  dataId,
  current,
  onSearchChange,
  onSearchKeyDown,
  onToggle,
  isOpen,
} = {}) => (
  <div className={bindClasses('wrapper')} data-ppuc-id={dataId}>
    <TextField
      name="search"
      icon="search"
      value={search}
      onChange={e => onSearchChange(e, isOpen)}
      clearable
      autoFocus
      onKeyDown={e => onSearchKeyDown(e, onToggle, isOpen)}
      dataId={`${dataId}.search`}
    />
    <div className={bindClasses('dimensions-list', { 'scroll-container': dimensions.length > 0 })}>
      <ActionList
        groups={dimensions.length === 0 ? [] : [{
          id: 'custom-dimensions',
          items: dimensions.map((item => ({
            ...item,
            name: (
              <div className={bindClasses('dimension')}>
                <div className={bindClasses('dimension-name')}>
                  {item.value.name}
                </div>
                <div className={bindClasses('dimension-id')}>
                  {`ID: ${item.value.id}`}
                </div>
              </div>
            ),
          }))),
        }]}
        onItemSelected={onItemSelected}
        // dataId={`${dataId}.options`} TODO: uncomment in PPUCC-378
        current={current}
      />
    </div>
  </div>
);

CustomDimensionsList.defaultProps = {
  dataId: 'CustomDimensionsList',
  isOpen: false,
  onToggle: () => {},
};

export { CustomDimensionsList };
